module.exports = __webpack_public_path__ + "img/factura_preautorizar.81252320.png";